(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hld-checklist-gate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'hld-checklist-unlocked';
    var root = document.querySelector('[data-hld-gate]');
    if (!root) return;
    var card = root.querySelector('[data-hld-gate-card]');
    var body = root.querySelector('[data-hld-gate-content]');
    if (!card || !body) return;

    // remember: true = this device, 'session' = this visit, false = don't persist
    // keepCard: leave the card in place instead of collapsing it — used only for
    // the just-submitted success panel, which is a message, not a form.
    function unlock(remember, keepCard) {
      try {
        if (remember === true) localStorage.setItem(KEY, '1');
        else if (remember === 'session') sessionStorage.setItem(KEY, '1');
      } catch (e) {}
      if (!keepCard) card.hidden = true;
      body.hidden = false;
    }

    var params = new URLSearchParams(location.search);
    var stored = false, session = false;
    try { stored = localStorage.getItem(KEY) === '1'; } catch (e) {}
    try { session = sessionStorage.getItem(KEY) === '1'; } catch (e) {}

    // Two tiers of unlock, deliberately.
    //
    // Giving an address on THIS device is a durable signal, so a form submit is
    // remembered in localStorage and they never see the gate again.
    //
    // `?unlocked=1` is not. It rides on the Welcome emails so subscribers aren't
    // asked twice for the address they just gave — but it is a shareable string
    // in a URL, and when it wrote localStorage a single click unlocked that
    // browser permanently. That is why Alan reported "no opt-in to see the
    // content" on 2026-08-05 while a clean session showed the gate correctly:
    // he had followed an email link earlier and his browser stayed open. It now
    // unlocks the VISIT (sessionStorage), which is all that journey needs.
    //
    // The success panel stays on screen (keepCard) rather than being collapsed
    // with the form it replaced. It carries the "Prefer it on paper?" PDF link,
    // which Alan moved out of the page hero on 2026-08-06 — hiding the panel
    // would hide the link with it, and a submit that erases everything it just
    // said reads as a page glitch rather than a confirmation.
    if (card.querySelector('.hld-signup__success')) unlock(true, true);
    else if (params.get('unlocked') === '1') unlock('session');
    else if (stored || session) unlock(false);

    // Remember the unlock at the moment of submit, not only on the way back.
    //
    // The form posts natively and the page reloads, and the success panel is the
    // only server-side signal that it worked — but Shopify can bounce the post
    // (a captcha challenge is the common one) and redirect back with no success
    // panel and no error. That left someone who HAD filled the form in staring
    // at the gate again. The address is captured or not on Shopify's side either
    // way; holding the content back on top of that just punishes the visitor.
    // It is a lead magnet, not a paywall.
    var form = card.querySelector('form.hld-signup__form');
    if (form) form.addEventListener('submit', function () {
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hld-cross-sell"] && !Shopify.designMode) return;
  try {
    
  // Async-load Shopify Product Recommendations into the cross-sell slot.
  // Tries each intent in data-intents order — "complementary" (curated in the
  // Search & Discovery app) first, then "related" (Shopify's auto algorithm) as
  // a fallback — so merchant curation reflects but the row is never empty.
  // Unique tag name to avoid clashing with any theme element.
  if (!customElements.get('hld-recommendations')) {
    customElements.define('hld-recommendations', class extends HTMLElement {
      connectedCallback() {
        const base = this.dataset.base;
        if (!base) return; // already a rendered result, not a shell — nothing to fetch
        const intents = (this.dataset.intents || 'related').split(',').filter(Boolean);
        this.tryIntent(base, intents, 0);
      }
      /* Handle of a rendered card, read off its product link, for de-duping. */
      handleOf(card) {
        const a = card.querySelector('a[href*="/products/"]');
        if (!a) return '';
        const m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
        return m ? m[1] : '';
      }
      tryIntent(base, intents, i) {
        const ownGrid = this.querySelector('[data-hld-xsell-grid]');
        if (i >= intents.length) {
          // Nothing came back from any intent. With a bundle card already on the page
          // the section stays as it is (one card beats an empty band); otherwise go.
          if (!ownGrid) this.remove();
          return;
        }
        fetch(base + '&intent=' + intents[i])
          .then((r) => r.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const fresh = doc.querySelector('.hld-cross-sell');
            const grid = fresh && fresh.querySelector('.hld-cross-sell__grid');
            if (!(grid && grid.children.length)) {
              this.tryIntent(base, intents, i + 1); // empty for this intent — try the next
              return;
            }
            if (!ownGrid) {
              this.replaceWith(fresh); // no bundle slot: populated result — swap in as before
              return;
            }
            // Bundle slot first, then the algorithm's picks, never the bundle twice.
            const max = parseInt(this.dataset.max, 10) || 3;
            const bundle = this.dataset.bundleHandle || '';
            [...grid.children]
              .filter((card) => this.handleOf(card) !== bundle)
              .slice(0, Math.max(0, max - ownGrid.children.length))
              .forEach((card) => ownGrid.appendChild(card));
          })
          .catch((e) => { console.error('[hld-cross-sell]', e); this.tryIntent(base, intents, i + 1); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hld-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Band "view" = at least half of it on screen, once per page. Mirrors the
    // popup's view event so the two surfaces' opt-in rates compare like for like.
    // The form's own events (interact, step2, submit, signup) come from
    // snippets/hld-signup-form.liquid.
    var band = document.querySelector('.hld-footer__band');
    if (!band || band.dataset.viewWired || !('IntersectionObserver' in window)) return;
    band.dataset.viewWired = '1';
    if (band.querySelector('.hld-signup__success')) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.disconnect();
        if (typeof window.hldTrack === 'function') window.hldTrack('hld_checklist_view', { placement: 'footer-band' });
      });
    }, { threshold: 0.5 });
    io.observe(band);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hld-guide-deck"] && !Shopify.designMode) return;
  try {
    

  /* <hld-flip-deck> — tap-to-pin, the shared readout, and the cursor micro-tilt.
     Hover-to-flip is CSS, so everything here is enhancement: with the script
     absent the cards still show a correct front face and still turn on hover. */
  class HLDFlipDeck extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = '1';

      this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

      const section = this.closest('.hld-deck');
      this.readout = section && section.querySelector('.hld-deck__readout');
      this.idle = this.readout ? this.readout.innerHTML : null;

      this.seq = 0; // click order, so the readout can follow the newest pin
      this.slots = Array.from(this.querySelectorAll('.hld-deck__slot'));
      this.slots.forEach((slot) => this.wire(slot));
      this.wireStepper(section);
    }

    /* Narrow-screen stepper. It drives the same scroll container the swipe does,
       so the two cannot disagree about which card is showing — the arrows scroll
       the rail, and the rail's own scroll event is what updates the counter. */
    wireStepper(section) {
      // A bundle has one deck (and one nav) per pack panel, so look in the
      // panel first; a single-pack page has no data-deck-scope and is unchanged.
      const scope = this.closest('[data-deck-scope]') || section;
      const nav = scope && scope.querySelector('.hld-deck__nav');
      if (!nav) return;
      const arrows = Array.from(nav.querySelectorAll('.hld-deck__arrow'));
      const counter = nav.querySelector('.hld-deck__count b');

      const index = () => {
        // Nearest slot centre to the viewport centre of the rail.
        // offsetLeft is measured against offsetParent, which is why the CSS makes
        // the rail positioned — otherwise these are page coordinates and the
        // arithmetic only works by luck when the rail happens to start at x≈0.
        const mid = this.scrollLeft + this.clientWidth / 2;
        let best = 0, bestGap = Infinity;
        this.slots.forEach((s, i) => {
          const gap = Math.abs(s.offsetLeft + s.offsetWidth / 2 - mid);
          if (gap < bestGap) { bestGap = gap; best = i; }
        });
        return best;
      };

      const sync = () => {
        const i = index();
        if (counter) counter.textContent = String(i + 1);
        // scrollWidth <= clientWidth means the fan is laid out, not railed —
        // desktop, where the nav is hidden and both arrows would read as dead.
        const railed = this.scrollWidth > this.clientWidth + 2;
        arrows.forEach((a) => {
          const dir = Number(a.dataset.dir);
          a.disabled = railed && ((dir < 0 && i === 0) || (dir > 0 && i === this.slots.length - 1));
        });
      };

      arrows.forEach((a) => {
        a.addEventListener('click', () => {
          const next = Math.min(this.slots.length - 1, Math.max(0, index() + Number(a.dataset.dir)));
          const slot = this.slots[next];
          if (!slot) return;
          /* Assign scrollLeft rather than scrollTo({behavior:'smooth'}): the rail
             is scroll-snap-type: x mandatory, and a smooth programmatic scroll is
             cancelled by the snap and springs back to where it started. */
          this.scrollLeft = slot.offsetLeft - (this.clientWidth - slot.offsetWidth) / 2;
          /* And drive the readout directly. Some engines fire NO scroll event for
             a programmatic scroll, so leaving this to the scroll listener leaves
             the counter stuck on 1 and `prev` disabled forever — which also makes
             the back arrow permanently unclickable. */
          sync();
        });
      });

      let tick;
      this.addEventListener('scroll', () => {
        clearTimeout(tick);
        tick = setTimeout(sync, 90);
      }, { passive: true });
      addEventListener('resize', sync, { passive: true });
      // Exposed so the bundle tabs can re-measure a panel that was display:none.
      this.sync = sync;
      sync();
    }

    wire(slot) {
      const card = slot.querySelector('.hld-deck__card');
      const stage = slot.querySelector('.hld-deck__stage');
      if (!card || !stage) return;

      /* hover and pinned are tracked separately on purpose. It is what stops a
         tapped card un-flipping the moment the finger lifts, and what lets a
         mouse user click to hold a card turned while they read it.
         `focus` never flips the card — CSS :focus-visible does that, and folding
         it in here would leave a mouse-clicked card stuck flipped, since a click
         focuses the button too. It is tracked only so the readout can follow the
         keyboard. */
      const state = { hover: false, pinned: false, focus: false };
      slot.hldState = state;

      const paint = () => {
        const back = state.hover || state.pinned;
        card.classList.toggle('is-flipped', back);
        slot.classList.toggle('is-showing-back', back);
        card.setAttribute('aria-pressed', String(state.pinned));
        this.refresh();
      };

      card.addEventListener('click', () => {
        /* On touch there is no hover, so the pin IS the flip. */
        state.pinned = !state.pinned;
        // More than one card can be pinned at once. Stamp the order so the
        // readout can describe the one just acted on rather than the oldest.
        if (state.pinned) state.seq = ++this.seq;
        paint();
      });

      /* Only KEYBOARD focus counts. A mouse click focuses the button as well, and
         counting that left the readout describing the clicked card for the rest
         of the visit — hover any other card afterwards and its copy never
         appeared. :focus-visible is the browser's own answer to "did this come
         from the keyboard?", and it is the same test the CSS uses to decide
         whether focus should flip the card, so the two now agree. */
      card.addEventListener('focus', () => { state.focus = card.matches(':focus-visible'); this.refresh(); });
      card.addEventListener('blur', () => { state.focus = false; this.refresh(); });

      if (!this.fine) return;

      stage.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        state.hover = true;
        paint();
      });
      stage.addEventListener('pointerleave', () => {
        state.hover = false;
        card.style.removeProperty('--tiltx');
        card.style.removeProperty('--tilty');
        card.style.removeProperty('--lift');
        paint();
      });

      if (this.reduce) return;

      /* Micro-tilt: the card leans a couple of degrees towards the cursor.
         Small enough to read as weight rather than as a gimmick. */
      stage.addEventListener('pointermove', (e) => {
        if (e.pointerType !== 'mouse') return;
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--tilty', (x * 6).toFixed(2) + 'deg');
        card.style.setProperty('--tiltx', (-y * 6).toFixed(2) + 'deg');
        card.style.setProperty('--lift', '-8px');
      });
    }

    /* The readout is DERIVED from the state of the whole deck, every time
       anything changes. It is deliberately not written by whichever handler fired
       last: that let a card you had just moved off overwrite the caption of a
       different card that was still pinned open, so the flipped card ended up
       described by its neighbour's front label — or by nothing at all.

       Priority: whatever the cursor or keyboard is on wins, because that is the
       card the shopper is looking at; failing that, a pinned card; failing that,
       the idle line. A card is only ever "active" while showing its back, so the
       back caption is always the right side to read. */
    refresh() {
      if (!this.readout) return;
      const active =
        this.slots.find((s) => s.hldState && s.hldState.hover) ||
        this.slots.find((s) => s.hldState && s.hldState.focus) ||
        this.slots
          .filter((s) => s.hldState && s.hldState.pinned)
          .sort((a, b) => (b.hldState.seq || 0) - (a.hldState.seq || 0))[0];

      if (!active) {
        if (this.idle !== null) this.readout.innerHTML = this.idle;
        return;
      }
      const side = active.querySelector('[data-side="back"]');
      if (!side) return;
      const label = side.querySelector('.hld-deck__cap-label');
      const sub = side.querySelector('.hld-deck__cap-sub');
      this.readout.innerHTML =
        '<span class="hld-deck__readout-label">' + (label ? label.innerHTML : '') + '</span>' +
        '<span class="hld-deck__readout-sub">' + (sub ? sub.innerHTML : '') + '</span>';
    }
  }

  if (!customElements.get('hld-flip-deck')) {
    customElements.define('hld-flip-deck', HLDFlipDeck);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hld-guide-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hld-guide-videos')) {
    customElements.define('hld-guide-videos', class extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const io = new IntersectionObserver((entries) => {
          entries.forEach(({ target: v, isIntersecting }) => {
            if (isIntersecting) {
              const s = v.querySelector('source[data-src]');
              if (s) { s.src = s.dataset.src; s.removeAttribute('data-src'); v.load(); }
              v.play().catch(() => {});
            } else v.pause();
          });
        }, { threshold: 0.35 });
        this.querySelectorAll('video').forEach((v) => io.observe(v));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hld-home-clips"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hld-home-clips')) {
    customElements.define('hld-home-clips', class extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const io = new IntersectionObserver((entries) => {
          entries.forEach(({ target: v, isIntersecting }) => {
            if (isIntersecting) {
              const s = v.querySelector('source[data-src]');
              if (s) { s.src = s.dataset.src; s.removeAttribute('data-src'); v.load(); }
              v.play().catch(() => {});
            } else v.pause();
          });
        }, { threshold: 0.35 });
        this.querySelectorAll('video').forEach((v) => io.observe(v));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hld-inside-deck"] && !Shopify.designMode) return;
  try {
    
  /* <hld-flip-deck> — tap-to-pin, the shared readout, and the cursor micro-tilt.
     Hover-to-flip is CSS, so everything here is enhancement: with the script
     absent the cards still show a correct front face and still turn on hover. */
  class HLDFlipDeck extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = '1';

      this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

      const section = this.closest('.hld-deck');
      this.readout = section && section.querySelector('.hld-deck__readout');
      this.idle = this.readout ? this.readout.innerHTML : null;

      this.seq = 0; // click order, so the readout can follow the newest pin
      this.slots = Array.from(this.querySelectorAll('.hld-deck__slot'));
      this.slots.forEach((slot) => this.wire(slot));
      this.wireStepper(section);
    }

    /* Narrow-screen stepper. It drives the same scroll container the swipe does,
       so the two cannot disagree about which card is showing — the arrows scroll
       the rail, and the rail's own scroll event is what updates the counter. */
    wireStepper(section) {
      // A bundle has one deck (and one nav) per pack panel, so look in the
      // panel first; a single-pack page has no data-deck-scope and is unchanged.
      const scope = this.closest('[data-deck-scope]') || section;
      const nav = scope && scope.querySelector('.hld-deck__nav');
      if (!nav) return;
      const arrows = Array.from(nav.querySelectorAll('.hld-deck__arrow'));
      const counter = nav.querySelector('.hld-deck__count b');

      const index = () => {
        // Nearest slot centre to the viewport centre of the rail.
        // offsetLeft is measured against offsetParent, which is why the CSS makes
        // the rail positioned — otherwise these are page coordinates and the
        // arithmetic only works by luck when the rail happens to start at x≈0.
        const mid = this.scrollLeft + this.clientWidth / 2;
        let best = 0, bestGap = Infinity;
        this.slots.forEach((s, i) => {
          const gap = Math.abs(s.offsetLeft + s.offsetWidth / 2 - mid);
          if (gap < bestGap) { bestGap = gap; best = i; }
        });
        return best;
      };

      const sync = () => {
        const i = index();
        if (counter) counter.textContent = String(i + 1);
        // scrollWidth <= clientWidth means the fan is laid out, not railed —
        // desktop, where the nav is hidden and both arrows would read as dead.
        const railed = this.scrollWidth > this.clientWidth + 2;
        arrows.forEach((a) => {
          const dir = Number(a.dataset.dir);
          a.disabled = railed && ((dir < 0 && i === 0) || (dir > 0 && i === this.slots.length - 1));
        });
      };

      arrows.forEach((a) => {
        a.addEventListener('click', () => {
          const next = Math.min(this.slots.length - 1, Math.max(0, index() + Number(a.dataset.dir)));
          const slot = this.slots[next];
          if (!slot) return;
          /* Assign scrollLeft rather than scrollTo({behavior:'smooth'}): the rail
             is scroll-snap-type: x mandatory, and a smooth programmatic scroll is
             cancelled by the snap and springs back to where it started. */
          this.scrollLeft = slot.offsetLeft - (this.clientWidth - slot.offsetWidth) / 2;
          /* And drive the readout directly. Some engines fire NO scroll event for
             a programmatic scroll, so leaving this to the scroll listener leaves
             the counter stuck on 1 and `prev` disabled forever — which also makes
             the back arrow permanently unclickable. */
          sync();
        });
      });

      let tick;
      this.addEventListener('scroll', () => {
        clearTimeout(tick);
        tick = setTimeout(sync, 90);
      }, { passive: true });
      addEventListener('resize', sync, { passive: true });
      // Exposed so the bundle tabs can re-measure a panel that was display:none.
      this.sync = sync;
      sync();
    }

    wire(slot) {
      const card = slot.querySelector('.hld-deck__card');
      const stage = slot.querySelector('.hld-deck__stage');
      if (!card || !stage) return;

      /* hover and pinned are tracked separately on purpose. It is what stops a
         tapped card un-flipping the moment the finger lifts, and what lets a
         mouse user click to hold a card turned while they read it.
         `focus` never flips the card — CSS :focus-visible does that, and folding
         it in here would leave a mouse-clicked card stuck flipped, since a click
         focuses the button too. It is tracked only so the readout can follow the
         keyboard. */
      const state = { hover: false, pinned: false, focus: false };
      slot.hldState = state;

      const paint = () => {
        const back = state.hover || state.pinned;
        card.classList.toggle('is-flipped', back);
        slot.classList.toggle('is-showing-back', back);
        card.setAttribute('aria-pressed', String(state.pinned));
        this.refresh();
      };

      card.addEventListener('click', () => {
        /* On touch there is no hover, so the pin IS the flip. */
        state.pinned = !state.pinned;
        // More than one card can be pinned at once. Stamp the order so the
        // readout can describe the one just acted on rather than the oldest.
        if (state.pinned) state.seq = ++this.seq;
        paint();
      });

      /* Only KEYBOARD focus counts. A mouse click focuses the button as well, and
         counting that left the readout describing the clicked card for the rest
         of the visit — hover any other card afterwards and its copy never
         appeared. :focus-visible is the browser's own answer to "did this come
         from the keyboard?", and it is the same test the CSS uses to decide
         whether focus should flip the card, so the two now agree. */
      card.addEventListener('focus', () => { state.focus = card.matches(':focus-visible'); this.refresh(); });
      card.addEventListener('blur', () => { state.focus = false; this.refresh(); });

      if (!this.fine) return;

      stage.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        state.hover = true;
        paint();
      });
      stage.addEventListener('pointerleave', () => {
        state.hover = false;
        card.style.removeProperty('--tiltx');
        card.style.removeProperty('--tilty');
        card.style.removeProperty('--lift');
        paint();
      });

      if (this.reduce) return;

      /* Micro-tilt: the card leans a couple of degrees towards the cursor.
         Small enough to read as weight rather than as a gimmick. */
      stage.addEventListener('pointermove', (e) => {
        if (e.pointerType !== 'mouse') return;
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--tilty', (x * 6).toFixed(2) + 'deg');
        card.style.setProperty('--tiltx', (-y * 6).toFixed(2) + 'deg');
        card.style.setProperty('--lift', '-8px');
      });
    }

    /* The readout is DERIVED from the state of the whole deck, every time
       anything changes. It is deliberately not written by whichever handler fired
       last: that let a card you had just moved off overwrite the caption of a
       different card that was still pinned open, so the flipped card ended up
       described by its neighbour's front label — or by nothing at all.

       Priority: whatever the cursor or keyboard is on wins, because that is the
       card the shopper is looking at; failing that, a pinned card; failing that,
       the idle line. A card is only ever "active" while showing its back, so the
       back caption is always the right side to read. */
    refresh() {
      if (!this.readout) return;
      const active =
        this.slots.find((s) => s.hldState && s.hldState.hover) ||
        this.slots.find((s) => s.hldState && s.hldState.focus) ||
        this.slots
          .filter((s) => s.hldState && s.hldState.pinned)
          .sort((a, b) => (b.hldState.seq || 0) - (a.hldState.seq || 0))[0];

      if (!active) {
        if (this.idle !== null) this.readout.innerHTML = this.idle;
        return;
      }
      const side = active.querySelector('[data-side="back"]');
      if (!side) return;
      const label = side.querySelector('.hld-deck__cap-label');
      const sub = side.querySelector('.hld-deck__cap-sub');
      this.readout.innerHTML =
        '<span class="hld-deck__readout-label">' + (label ? label.innerHTML : '') + '</span>' +
        '<span class="hld-deck__readout-sub">' + (sub ? sub.innerHTML : '') + '</span>';
    }
  }

  if (!customElements.get('hld-flip-deck')) {
    customElements.define('hld-flip-deck', HLDFlipDeck);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
